<template>
  <div class="home">
    <el-container class="h100" direction="vertical">
      <my-header></my-header>
      <el-container class="container">
        <el-aside width="255px" class="aside">
          <Menu></Menu>
        </el-aside>
        <el-main class="grey">
          <breadcrumb></breadcrumb>
          <el-container class="main-x" direction="vertical">
            <router-view></router-view>
          </el-container>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Menu from "./components/Menu";
import Breadcrumb from "./components/Breadcrumb.vue";
import myHeader from "./components/Header.vue";
export default {
  name: "Home",
  components: { Menu, Breadcrumb, myHeader },
  computed: {},
  data() {
    return {
      // 导航数据示例
      // icon 属性用于传入图标
      menuData: [
        {
          title: "产品管理",
          icon: "el-icon-notebook-2",
          link: "/product",
        },
        {
          title: "订单管理",
          icon: "el-icon-suitcase",
          children: [
            {
              title: "二次诊疗",
              link: "",
            },
          ],
        },
        {
          title: "系统管理",
          icon: "el-icon-tickets",
          children: [
            {
              title: "用户管理",
              link: "/system/user",
            },
            {
              title: "角色管理",
              link: "/system/role",
            },
            {
              title: "系统日志",
              link: "/system/log",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped type="text/scss">
@import "@/assets/css/color.scss";
.container {
  overflow: auto;
}
.aside {
  background: #1a2a3a;
  height: calc(100vh - 50px);
  position: fixed;
}
.main-x {
  height: 100%;
  background-color: #fff;
  padding: 20px;
  margin-top: 34px;
  border-radius: 4px;
}
.grey {
  height: calc(100vh - 50px);
  margin-left: 255px;
  background-color: #f5f5f5;
  position: relative;
  padding: 14px;
}
</style>
